/** 讀取 Vite 公開環境變數（未設定時為空字串） */
function envPublic(key: string): string {
  const v = (import.meta.env as Record<string, string | undefined>)[key];
  return typeof v === 'string' ? v.trim() : '';
}

/** 公司登記資訊（About 頁、Footer、法律文件共用；與桃園市政府核准設立登記一致） */
export const SITE_COMPANY = {
  legalName: '快修通有限公司',
  brandName: '快修通',
  taxId: '62220459',
  representative: '馮桂豪',
  address: '325 桃園市龍潭區龍平路1107巷55弄21號',
  registeredAt: '115 年 4 月 7 日',
  registeredBy: '桃園市政府',
  gcisLookupUrl: 'https://gcis.nat.gov.tw/',
} as const;

/** 全站對外聯絡資訊（頁尾、聯絡頁、法律文件「聯絡我們」共用；與官網 techfix.com.tw 一致） */
export const SITE_CONTACT = {
  /** 登記／對外聯絡地址 */
  address: SITE_COMPANY.address,
  /** 對外顯示之客服信箱（與聯絡表單、Footer mailto 收件相同） */
  supportEmail: 'techfix.com.tw@gmail.com',
  /** 客服來電時段說明（法律文件與退款頁共用） */
  businessHours: '週一至週五 9:00-18:00',
} as const;

/** 聯絡頁表單「傳送訊息」之 mailto 收件（使用者於本機郵件 App 內按寄出） */
export const CONTACT_FORM_RECIPIENT_EMAIL = 'techfix.com.tw@gmail.com' as const;

/**
 * 退款／爭議等專用聯絡信箱（未設定 `VITE_REFUND_EMAIL` 時與客服信箱相同）
 */
export const SITE_REFUND_EMAIL = envPublic('VITE_REFUND_EMAIL') || SITE_CONTACT.supportEmail;

/** 隱私／資料權利聯絡信箱（未設定 `VITE_PRIVACY_EMAIL` 時與客服信箱相同） */
export const SITE_PRIVACY_EMAIL = envPublic('VITE_PRIVACY_EMAIL') || SITE_CONTACT.supportEmail;

/** 資料保護／DPO 聯絡信箱（未設定 `VITE_DPO_EMAIL` 時與隱私聯絡信箱相同） */
export const SITE_DPO_EMAIL = envPublic('VITE_DPO_EMAIL') || SITE_PRIVACY_EMAIL;

/** 稅務相關諮詢信箱（未設定 `VITE_TAX_EMAIL` 時與客服信箱相同） */
export const SITE_TAX_EMAIL = envPublic('VITE_TAX_EMAIL') || SITE_CONTACT.supportEmail;

/** 商業登記相關諮詢信箱（未設定 `VITE_BUSINESS_EMAIL` 時與客服信箱相同） */
export const SITE_BUSINESS_EMAIL = envPublic('VITE_BUSINESS_EMAIL') || SITE_CONTACT.supportEmail;

/**
 * 市話客服專線顯示文字。請在 `.env` 設定 `VITE_SUPPORT_PHONE`（例如 02-2345-6789）；
 * 未設定時不顯示假號碼，改引導以信箱聯繫。
 */
export const SITE_SUPPORT_PHONE_LINE =
  envPublic('VITE_SUPPORT_PHONE') ||
  `請優先寄信至 ${SITE_CONTACT.supportEmail}（尚未公告市話專線）`;

/** 社群連結預設值（公開；可被 VITE_SOCIAL_FACEBOOK_URL / VITE_SOCIAL_LINE_URL 覆寫） */
export const SITE_SOCIAL = {
  facebookUrl: 'https://www.facebook.com/profile.php?id=6157532488332',
  lineUrl: 'https://line.me/R/ti/p/@923fmscd',
} as const;
